module.exports = __webpack_public_path__ + "media/components/assets/dabang_bottle_04-3075db8382903022531958e7b79763b4.png";